function InputSelectAcciones({ value, setValue, label }) {

    return (
        <div className="form-group">
            <label>{label}</label>
            <select
                className="input"
                value={value || ""}
                onChange={(e) => setValue(e.target.value)}
            >
                <option value="" disabled>
                    Seleccione una opción
                </option>
                <option value="registro">Registro</option>
                <option value="modificacion">Modificación</option>
                <option value="eliminacion">Eliminación</option>
                <option value="inicio_sesion">Inicio de sesión</option>
            </select>
        </div>
    );
}

export default InputSelectAcciones;